<template>
  <div :class="classList">
    <label class="time-label">{{ label }}</label>
    <vue-timepicker
      class="form-control"
      format="HH:mm"
      :disabled="isDisabled"
      v-model="inputVal"
    ></vue-timepicker>
    <p
      class="required-message"
      v-if="
        (inputVal == null || inputVal.HH === '' || inputVal.mm === '') &&
          submitClicked &&
          isRequired &&
          !isDisabled
      "
    >
      This field is required.
    </p>
  </div>
</template>
<script>
/* This component includes a label, and a time picker
Any error of user input for the time picker (for example: required field, invalid time ...) is showed in this component */
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  name: "TimePickerWithLabel",
  components: {
    VueTimepicker
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12"
    },
    // Input value, which is used for v-model
    value: [String, Object],
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false
    },
    // true if disable the timepicker
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style scoped>
.time-label {
  display: inline-block;
  width: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TimePickerWithLabel.vue